<script setup>
defineProps({
    personal: {
        type: Boolean,
        required: true,
    }
})
</script>

<template>
    <svg v-if="personal"
         width="15"
         height="15"
         viewBox="0 0 15 15"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd"
              clip-rule="evenodd"
              d="M10.5 3.49804C10.5 5.15396 9.157 6.49609 7.5 6.49609C5.843 6.49609 4.5 5.15396 4.5 3.49804C4.5 1.84212 5.843 0.5 7.5 0.5C9.157 0.5 10.5 1.84212 10.5 3.49804Z"
              stroke-linecap="square"/>
        <path fill-rule="evenodd"
              clip-rule="evenodd"
              d="M12.5 14.4909H2.5C2.5 13.7808 2.5 13.1053 2.5 12.4936C2.5 10.8368 3.84315 9.49414 5.5 9.49414H9.5C11.1569 9.49414 12.5 10.8368 12.5 12.4936C12.5 13.1053 12.5 13.7808 12.5 14.4909Z"
              stroke-linecap="square"/>
    </svg>
    <svg v-else
         width="15"
         height="16"
         viewBox="0 0 15 16"
         fill="none"
         xmlns="http://www.w3.org/2000/svg">
        <path d="M5.5 3.5V3C5.5 1.89543 6.39543 1 7.5 1C8.60457 1 9.5 1.89543 9.5 3V3.5M0.5 12H14.5M1.5 4H13.5C14.0523 4 14.5 4.44772 14.5 5V14C14.5 14.5523 14.0523 15 13.5 15H1.5C0.947716 15 0.5 14.5523 0.5 14V5C0.5 4.44772 0.947715 4 1.5 4Z"/>
    </svg>

</template>
